import React from 'react';
import { Link } from 'react-router-dom';
import { debtResolutionProcessSteps } from '../data/sharedSteps';
import { PAGE_META } from '../data/pageMetaConfig';
import SimpleContactButton from '../components/SimpleCBT';

const linkClass = 'text-amber-600 hover:text-amber-700 font-semibold underline';
const path = '/debt-settlement-lawyer';

export const pageMeta = {
  title: PAGE_META[path].title,
  metaDescription: PAGE_META[path].description,
  path,
  h1: 'עורך דין להסדר חובות',
  faqSubtitle: 'מצאו תשובות לשאלות נפוצות בנוגע להסדרי חוב, מו״מ מול נושים והפחתת חובות.',
};

export const steps = debtResolutionProcessSteps;

export const faq = [
  {
    question: 'מה זה הסדר חובות?',
    answer:
      'הסדר חובות הוא ניסיון להגיע להסכמה מול הנושים לגבי אופן תשלום החוב – למשל פריסה, תשלום מוסכם או הפחתה מסוימת במקרים המתאימים.',
  },
  {
    question: 'האם אפשר להפחית חוב במסגרת הסדר?',
    answer:
      'במקרים מסוימים כן, אך זה תלוי בסוג החוב, זהות הנושה, מצב התיק ויכולת ההחזר. אין הבטחה להפחתה, אבל ניתן לבחון אפשרות כזו.',
  },
  {
    question: 'האם הסדר חובות מתאים לכל אחד?',
    answer:
      'לא. הסדר חובות מתאים בעיקר כשיש יכולת מסוימת לשלם וניתן להגיע להסכמה מול הנושים. אם החובות גבוהים מאוד ואין יכולת החזר, ייתכן שצריך לבחון פתרון אחר.',
  },
  {
    question: 'האם אפשר לעשות הסדר חוב גם אחרי שנפתח תיק בהוצאה לפועל?',
    answer:
      'כן. גם לאחר פתיחת תיק בהוצאה לפועל ניתן במקרים המתאימים לנסות להגיע להסדר מול הנושה ולעדכן את התיק בהתאם להסכמות.',
  },
  {
    question: 'האם הסדר חוב עוצר עיקולים?',
    answer:
      'הסדר חוב יכול לכלול בקשה לעצירת הליכים או ביטול עיקולים, אך זה תלוי בהסכמות ובהחלטות הגורמים הרלוונטיים. חשוב לוודא שהדבר מוסדר בכתב.',
  },
  {
    question: 'האם אפשר להגיע להסדר חוב מול הבנק?',
    answer:
      'כן. במקרים המתאימים ניתן לנהל משא ומתן מול הבנק ולבחון אפשרות לפריסת החוב, שינוי תנאי ההחזר או הסדר מוסכם. חשוב לבדוק את מצב החוב לפני שמתחייבים להסדר.',
  },
];

export const sections = [
  {
    title: 'לא מצליחים לעמוד בתשלומים? יש דרך לעשות סדר בחובות',
    content: (
      <>
        <p>
          לא כל אדם שנמצא בחובות חייב להיכנס מיד להליך חדלות פירעון. לפעמים, לפני שפונים להליך
          משפטי רחב יותר, אפשר לבדוק אפשרות של הסדר חובות – כלומר ניסיון להגיע להסכמה מול הנושים,
          לפרוס את החוב, להפחית חלק ממנו במקרים המתאימים, לעצור הליכים ולבנות תכנית החזר שאפשר
          לעמוד בה.
        </p>
        <p>
          הרבה אנשים מגיעים למצב שבו הם כבר לא מצליחים לשלם בזמן. עוד הלוואה, עוד מסגרת אשראי,
          עוד שיחה מהבנק או מנושה – ופתאום החוב גדל והלחץ רק מתגבר. במשרד מיכלסון ושות׳ אנחנו
          מלווים חייבים בגיבוש הסדרי חוב, ניהול משא ומתן מול נושים, טיפול בהליכי הוצאה לפועל
          ובחינת האפשרות להפחתת חובות או פריסת חובות בהתאם לנסיבות.
        </p>
        <p>
          המטרה שלנו היא פשוטה: לבדוק את מצב החובות שלכם, להבין מול מי מתנהלים, לבחון אם ניתן
          להגיע להסדר – ולבנות עבורכם דרך פעולה מסודרת לפני שהמצב מחמיר.
        </p>
      </>
    ),
  },
  {
    title: 'מהו הסדר חובות?',
    content: (
      <>
        <p>
          הסדר חובות הוא ניסיון להגיע להסכמה מול נושה אחד או כמה נושים לגבי אופן תשלום החוב.
          במילים פשוטות: במקום שהחוב ימשיך להתגלגל, לצבור ריביות, לגרור עיקולים או הליכים –
          מנסים להגיע להסכמה ברורה: כמה משלמים, מתי משלמים, האם יש פריסה, והאם ניתן להפחית חלק
          מהחוב במקרים המתאימים.
        </p>
        <p>
          הסדר חובות יכול להתאים במצבים שונים, למשל מול בנקים, חברות אשראי, ספקים, אנשים
          פרטיים, רשויות או נושים אחרים. חשוב להבין: הסדר חוב לא קורה אוטומטית. צריך לבדוק את
          גובה החוב, מצב התיק, זהות הנושה, היכולת הכלכלית שלכם והאם קיימת אפשרות אמיתית להגיע
          להסכמה.
        </p>
      </>
    ),
  },
  {
    title: 'מתי הסדר חובות יכול להתאים?',
    content: (
      <>
        <p>
          הסדר חובות יכול להתאים במיוחד כאשר קיימת יכולת מסוימת לשלם, אבל לא בתנאים הנוכחיים.
          לדוגמה:
        </p>
        <ul>
          <li>יש חוב אחד או כמה חובות שניתן לנהל עליהם משא ומתן.</li>
          <li>יש אפשרות לשלם סכום מסוים בתשלום אחד או בפריסה.</li>
          <li>החייב רוצה להימנע מהחמרת הליכים.</li>
          <li>יש תיק בהוצאה לפועל ורוצים לנסות לסגור אותו בהסכמה.</li>
          <li>קיימת אפשרות לגייס סכום מסוים ממשפחה או מקור אחר.</li>
          <li>
            רוצים להסדיר חוב לפני שנכנסים להליך{' '}
            <Link to="/insolvency-lawyer" className={linkClass}>
              חדלות פירעון
            </Link>
            .
          </li>
        </ul>
        <p>
          במקרים כאלה, כדאי לבדוק האם הסדר חוב יכול לתת פתרון מהיר, ממוקד ופחות מורכב.
        </p>
      </>
    ),
  },
  {
    title: 'האם אפשר להפחית חובות במסגרת הסדר?',
    content: (
      <>
        <p>
          במקרים מסוימים כן, אבל חשוב להגיד את זה בזהירות. הפחתת חוב תלויה בהרבה גורמים: סוג
          החוב, זהות הנושה, גיל החוב, מצב התיק, יכולת ההחזר, המסמכים הקיימים, והאם לנושה יש
          אינטרס להגיע להסדר.
        </p>
        <p>
          לפעמים ניתן להגיע לפריסה נוחה יותר. לפעמים ניתן להגיע לתשלום מופחת לסילוק החוב. לפעמים
          ההסדר יהיה בעיקר עצירת הליכים וסידור תשלומים. אין הבטחה שכל חוב יופחת, אבל בהחלט יש
          מקרים שבהם ניהול נכון של משא ומתן יכול לשפר משמעותית את המצב.
        </p>
      </>
    ),
  },
  {
    title: 'מתי כדאי לפנות לעורך דין הסדר חובות?',
    content: (
      <>
        <p>
          כדאי לפנות לייעוץ לפני שהחוב יוצא משליטה. הרבה פעמים אנשים מחכים עד שיש עיקולים, תיקים
          בהוצאה לפועל או לחץ כבד מהנושים. אבל דווקא פנייה מוקדמת יכולה לאפשר יותר אפשרויות
          פעולה. כדאי לפנות לייעוץ אם אתם מזהים אחד או יותר מהמצבים הבאים:
        </p>
        <ul>
          <li>יש לכם חובות לבנקים, חברות אשראי, ספקים או אנשים פרטיים.</li>
          <li>אתם מתקשים לעמוד בהחזרים החודשיים.</li>
          <li>קיבלתם מכתבי התראה לפני נקיטת הליכים.</li>
          <li>נפתח נגדכם תיק בהוצאה לפועל.</li>
          <li>אתם רוצים להגיע להסדר לפני שהמצב מחמיר.</li>
          <li>אתם שוקלים לקחת עוד הלוואה כדי לסגור חוב קודם.</li>
          <li>יש לכם כמה נושים ואתם לא יודעים למי לשלם קודם.</li>
          <li>אתם רוצים לבדוק אם אפשר להפחית חלק מהחוב.</li>
          <li>
            אתם לא בטוחים אם מתאים לכם הסדר חובות או{' '}
            <Link to="/insolvency-lawyer" className={linkClass}>
              חדלות פירעון
            </Link>
            .
          </li>
        </ul>
        <p>
          בשלב הזה חשוב לא לפעול מתוך לחץ. לפני שמתחייבים להסדר, משלמים סכומים גדולים או חותמים
          על מסמך – כדאי לבדוק שההסדר באמת מתאים לכם ושומר עליכם.
        </p>
        <div className="not-prose">
          <SimpleContactButton className="mt-8 !mb-8" />
        </div>
      </>
    ),
  },
  {
    title: 'איך עורך דין הסדר חובות יכול לעזור?',
    content: (
      <>
        <p>
          עורך דין להסדר חובות לא רק &quot;מבקש הנחה&quot; מהנושה. התפקיד שלו הוא לבדוק את כל
          התמונה, להבין מה מצב החוב, מה הסיכונים, מה יכולת ההחזר, ומה הדרך הנכונה לנהל את המשא
          ומתן. במשרדנו הליווי כולל בין היתר:
        </p>
        <h3>בדיקת מצב החובות</h3>
        <p>
          בשלב הראשון אנחנו בודקים למי אתם חייבים כסף, מה סכומי החוב, האם יש תיקים בהוצאה לפועל,
          האם ננקטו הליכים, האם קיימים עיקולים, ומה היכולת הכלכלית שלכם בפועל. המטרה היא להבין
          את התמונה האמיתית – לא רק את הסכום שמופיע במכתב או בתיק.
        </p>
        <h3>בחינת האפשרות להסדר</h3>
        <p>
          לא כל חוב ניתן להפחתה, ולא כל נושה יסכים להסדר. לכן צריך לבדוק האם יש בסיס אמיתי לנהל
          משא ומתן, מה ניתן להציע, ומה הסיכוי להגיע להסכמה. במקרים המתאימים, ניתן לבחון פריסת
          תשלומים, תשלום חד־פעמי מופחת, הקפאת הליכים או הסדר כולל מול כמה נושים.
        </p>
        <h3>ניהול משא ומתן מול נושים</h3>
        <p>
          ניהול מו״מ מול נושה צריך להיעשות בצורה מסודרת, זהירה ומתועדת. אנחנו פונים לנושים,
          מציגים את המצב, בוחנים אפשרויות להסדר ופועלים כדי להגיע לפתרון שמצד אחד יהיה אפשרי
          עבורכם, ומצד שני יוכל להתקבל על ידי הנושה.
        </p>
        <h3>ניסוח הסכם הסדר חוב</h3>
        <p>
          גם אם מגיעים להבנה בעל פה – זה לא מספיק. חשוב שההסדר יהיה כתוב בצורה ברורה: מה סכום
          החוב המוסכם, כמה משלמים, מתי משלמים, האם מדובר בסילוק סופי, מה קורה עם עיקולים, ומה
          קורה אם אחד הצדדים לא עומד בהסכם. הסכם לא ברור עלול ליצור בעיות בהמשך, ולכן חשוב לוודא
          שכל התנאים מוסדרים בכתב.
        </p>
        <h3>טיפול בהליכי הוצאה לפועל</h3>
        <p>
          אם כבר נפתח תיק בהוצאה לפועל, הסדר החוב צריך להשתלב עם מצב התיק. במקרים המתאימים,
          ניתן לבחון בקשות לעיכוב הליכים, ביטול או צמצום עיקולים, עדכון ההסדר בתיק או בקשה
          לסגירת תיק לאחר ביצוע ההסדר.
        </p>
        <h3>בחינה אם צריך פתרון רחב יותר</h3>
        <p>
          לפעמים הסדר חובות מול נושה אחד לא מספיק, כי קיימים חובות רבים ואין יכולת אמיתית לעמוד
          בהם. במצב כזה צריך לבחון האם מתאים יותר לפעול במסגרת איחוד תיקים או{' '}
          <Link to="/insolvency-lawyer" className={linkClass}>
            הליך חדלות פירעון ושיקום כלכלי
          </Link>
          . המטרה היא לא לבחור פתרון שנשמע טוב על הנייר – אלא פתרון שבאמת מתאים למצב שלכם.
        </p>
      </>
    ),
  },
];
